import { Form, Input, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { NAME_LANGUAGES } from '@/shared/lib/planName'

/**
 * Nomning uch tildagi maydonlari — paket va siyosat formasi UCHUN BITTA.
 *
 * ⚠️ Nusxa ko'chirilmasin: ikki formada ayri-ayri yozilsa, bir kuni
 * biri `trim()` ni yoki zaxira izohini unutardi va farq faqat ekranda
 * bilinardi.
 *
 * <h2>⚠️ Nega TAB emas, uchta maydon yonma-yon</h2>
 * Panelda ko'p tilli matn uchun naqsh allaqachon bor —
 * `notify/TemplateFormModal` da antd `Tabs`, har tilga bitta bet.
 * Bu yerda u ATAYLAB takrorlanmadi, ikki sabab bilan:
 *
 * 1. **U yerda tilga IKKI katta maydon** (mavzu + xat matni), bu yerda
 *    esa BITTA qisqa satr. Uchta qisqa satr bir ekranga sig'adi va
 *    operator ularni YONMA-YON ko'radi — ya'ni qaysi til bo'sh
 *    qolganini bilish uchun betlarni bosib chiqish shart emas.
 * 2. **Tab bilan birga ma'lum nuqson keladi (X-SIB-015):** antd tab
 *    tanasini kech ulaydi va ochilmagan betdagi maydonlar
 *    `validateFields()` natijasiga TUSHMAYDI. `TemplateFormModal` uni
 *    `getFieldsValue(true)` bilan aylanib o'tgan. Shu tuzoqni uchta
 *    oddiy maydon uchun qayta olib kirish o'rinsiz bo'lardi.
 *
 * <h2>⚠️ Birortasi ham MAJBURIY EMAS</h2>
 * Operator faqat bittasini to'ldirishi mumkin — qolgani kanonik nomga
 * (`name`) tushadi. Majburiy qilish operatorni uchala maydonga bir xil
 * matn ko'chirishga majburlardi: bu ma'lumotni yaxshilamaydi, faqat
 * tekshiruvni aldaydi.
 */
export function NameI18nFields() {
  const { t } = useTranslation()

  return (
    <>
      <Typography.Paragraph type="secondary" style={{ marginBottom: 8 }}>
        {t('catalog.nameI18n.hint')}
      </Typography.Paragraph>
      {NAME_LANGUAGES.map((lang) => (
        <Form.Item
          key={lang}
          name={['nameI18n', lang]}
          label={t(`catalog.nameI18n.label.${lang}`)}
          // ⚠️ `rules` YO'Q va bu ataylab — yuqoridagi izohga qarang.
        >
          <Input allowClear placeholder={t('catalog.nameI18n.placeholder')} />
        </Form.Item>
      ))}
    </>
  )
}
